import React, {Component} from 'react';
import Link from 'react-router-dom/Link';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_event_details';
import Button from '@material-ui/core/Button';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import IconAgepPeople from '../../../Layout/assets/img/icon-agep-people.svg';
import IconAgepClock from '../../../Layout/assets/img/icon-agep-clock.svg';
import IconAgepDoorway from '../../../Layout/assets/img/icon-agep-doorway.svg';
import '../../assets/scss/dialogEventCheckin.css';

class EventDetailsPlaceholder extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    render() {
        return (
            <article className="event placeholder">
                <header>
                    <div className="row no-gutters">
                        <div className="col col-left col-4 d-none d-lg-block">
                            <div id="aside">
                                <div className="inner">
                                    <div className="featured-image"></div>
                                    <div className="content">
                                        <address>
                                            <span className="title"><Translate id="event_details.place" /></span>
                                            <div className="place">
                                                <span className="place-name">
                                                    <span className="placeholder-line"></span>
                                                </span>
                                                <div className="place-address">
                                                    <span className="placeholder-line"></span>
                                                    <span className="placeholder-line"></span>
                                                </div>
                                            </div>
                                        </address>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col col-right col-12 col-lg-7 offset-lg-1">
                            <div className="wrapper-top">
                                <Button size="medium" className="btnBack" component={props => <Link to={this.props.translate('routes.events')} {...props}/>}>
                                    <KeyboardBackspaceIcon className="btnIcon" />
                                    <Translate id="event_details.button_back" />
                                </Button>

                                <div className="row row-content no-gutters">
                                    <div className="col col-12 order-lg-1 order-2">
                                        <h1>
                                            <span className="placeholder-line"></span>
                                            <span className="placeholder-line"></span>
                                        </h1>
                                    </div>
                                    <div className="col col-12 order-lg-2 order-1">
                                        <span className="category">
                                            <span className="placeholder-line"></span>
                                        </span>
                                    </div>
                                </div>

                                <div id="mobile-featured-image" className="d-block d-lg-none"></div>
                                <div id="mobile-featured-image-layer" className="d-block d-lg-none"></div>
                            </div>

                            <ul className="highlight clearfix">
                                <li>
                                    <div className="icon">
                                        <img src={IconAgepPeople} alt="Public" />
                                    </div>
                                    <div className="content">
                                        <span className="title">
                                            <Translate id="event_details.public" />
                                        </span>
                                        <span className="txt">
                                            <span className="placeholder-line"></span>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon">
                                        <img src={IconAgepClock} alt="Durée" />
                                    </div>
                                    <div className="content">
                                        <span className="title">
                                            <Translate id="event_details.duration" />
                                        </span>
                                        <span className="txt">
                                            <span className="placeholder-line"></span>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon">
                                        <img src={IconAgepDoorway} alt="Ouverture des portes" />
                                    </div>
                                    <div className="content">
                                        <span className="title">
                                            <Translate id="event_details.ouverture_portes" />
                                        </span>
                                        <span className="txt">
                                            <span className="placeholder-line"></span>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </header>
                <div className="row row-content">
                    <div className="col col-right col-12 col-lg-7 offset-lg-5">
                        <section id="description">
                            <h2><Translate id="event_details.description" /></h2>
                            <div className="content">
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                            </div>
                        </section>
                        <section id="event-dates">
                            <h2><Translate id="event_details.dates" /></h2>
                            <div className="content">
                                <ul className="items clearfix">
                                    <li>
                                        <span className="placeholder-line"></span>
                                    </li>
                                    <li>
                                        <span className="placeholder-line"></span>
                                    </li>
                                </ul>
                            </div>
                        </section>
                    </div>
                </div>
            </article>
        );
    }
}

export default withLocalize(EventDetailsPlaceholder);



// WEBPACK FOOTER //
// ./src/features/Events/components/Details/EventDetailsPlaceholder.js